import {
    Component,
    OnInit,
    Inject,
    ViewChild,
    TemplateRef,
} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

import { Observable, of } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// variavel global conexão no servidor
import { api } from '../environments/api';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    colorFont: any = {
        css_color_primary: 'colors rgb(40, 43, 43)',
        css_color_second: '#019474',
    };

    configGeral = {
        geral_type_delivery: '0',
        geral_product_full_age: false,
    };

    // Google TAG Manager ID
    GTM_ID;

    @ViewChild('modalAlert') modalContent: TemplateRef<any>;

    imageLogo = 'assets/images/pedenaweb-logo.png';

    modalRef: BsModalRef;
    config = {
        keyboard: false,
        ignoreBackdropClick: true,
        class: 'modal-sm',
    };

    constructor(
        private modalService: BsModalService,
        private http: HttpClient,
        private spinnera: NgxSpinnerService,
        private titleService: Title,
        private translate: TranslateService,
        @Inject(DOCUMENT) private _document: HTMLDocument
    ) {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('pt-br');
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(localStorage.getItem('lang') || 'pt-br');
    }

    ngOnInit() {
        this.requestBaseConfigs();
        this.getConfigGeral();

        /** spinner starts on init */
        this.spinnera.show();

        // setTimeout(() => {
        //     /** spinner ends after 5 seconds */
        //     this.spinnera.hide();
        // }, 2000);

        this.setDocTitle(api.owner);
        // this.addScriptsToHead();
    }

    getConfigGeral() {
        this.http.get(api.url + 'geral-config').subscribe(
            (response) => {
                this.configGeral.geral_type_delivery =
                    response['geral_type_delivery'];
                this.configGeral.geral_product_full_age =
                    response['geral_product_full_age'];

                if (this.configGeral.geral_product_full_age) {
                    // Carregar a logo do sistema do DB
                    if (
                        localStorage.getItem('alert-allow') === undefined ||
                        localStorage.getItem('alert-allow') === null ||
                        localStorage.getItem('alert-allow') === 'false' ||
                        localStorage.getItem('alert-allow') !== 'true'
                    ) {
                        setTimeout(() => {
                            this.modalRef = this.modalService.show(
                                this.modalContent,
                                this.config
                            );
                        }, 5000);
                    }
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    setDocTitle(title: string) {
        this.titleService.setTitle(title + ' | Delivery');
    }

    addScriptsToHead() {
        const head = document.getElementsByTagName('head')[0];

        this.GTM_ID = 'GTM-MPCF2ZN';

        const script = document.createElement('script');
        script.innerHTML =
            '(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : ""; j.async = true; j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl; f.parentNode.insertBefore(j, f); })(window, document, "script", "dataLayer", "' + this.GTM_ID + '");';

        head.insertBefore(script, head.firstChild);
    }

    // Permitir o acesso do usuário
    allowAcess() {
        localStorage.setItem('alert-allow', 'true');
    }

    requestBaseConfigs() {
        let loading = false;
        if (localStorage.length < 1) {
            loading = true;
        }

        this.http
            .get(api.url + 'companies/data')
            .pipe(retry(3))
            .subscribe((response) => {
                const company_data = response;

                // Organizando as imagens da company
                localStorage.setItem(
                    'company-image',
                    JSON.stringify(company_data['company_image'])
                );
                company_data['company_image'].forEach((value) => {
                    if (value['imag_name'] === 'favicon') {
                        this._document
                            .getElementById('appFavicon')
                            .setAttribute(
                                'href',
                                api.image + value['imag_path']
                            );
                    }

                    if (value['imag_name'] === 'logo') {
                        if (value['imag_path'] !== null) {
                            this.imageLogo = api.image + value['imag_path'];
                        }
                    }
                });
                // Organizando os CSS e customização do site
                for (const oneColor of company_data['company_css']) {
                    if (oneColor.css_sector === 'background') {
                        localStorage.setItem(
                            'bg-color-and-font',
                            JSON.stringify(oneColor)
                        );
                        this.colorFont = oneColor;
                    } else if (oneColor.css_sector === 'menu-background') {
                        localStorage.setItem(
                            'menu-bg-color',
                            JSON.stringify(oneColor)
                        );
                        this.colorFont = oneColor;
                    } else if (oneColor.css_sector === 'menu-font') {
                        localStorage.setItem(
                            'menu-font-color',
                            JSON.stringify(oneColor)
                        );
                        this.colorFont = oneColor;
                    } else if (oneColor.css_sector === 'footer-background') {
                        localStorage.setItem(
                            'footer-bg-color',
                            JSON.stringify(oneColor)
                        );
                        this.colorFont = oneColor;
                    } else if (oneColor.css_sector === 'footer-font') {
                        localStorage.setItem(
                            'footer-font-color',
                            JSON.stringify(oneColor)
                        );
                    } else if (oneColor.css_sector === 'font') {
                        localStorage.setItem(
                            'color-and-font',
                            JSON.stringify(oneColor)
                        );
                    } else if (oneColor.css_sector === 'font-hover') {
                        localStorage.setItem(
                            'color-and-font-hover',
                            JSON.stringify(oneColor)
                        );
                    } else if (oneColor.css_sector === 'font-body') {
                        localStorage.setItem(
                            'color-and-font-body',
                            JSON.stringify(oneColor)
                        );
                    } else if (oneColor.css_sector === 'menu-button') {
                        localStorage.setItem(
                            'menu-color-button',
                            JSON.stringify(oneColor)
                        );
                    } else if (oneColor.css_sector === 'button-order') {
                        localStorage.setItem(
                            'button-color-order',
                            JSON.stringify(oneColor)
                        );
                    } else if (oneColor.css_sector === 'button-menu-mobile') {
                        localStorage.setItem(
                            'button-menu-mobile',
                            JSON.stringify(oneColor)
                        );
                    }
                }

                // Organizando as páginas do site
                localStorage.setItem(
                    'page-home',
                    JSON.stringify(company_data['company_page'])
                );

                // Organizando os dados da company
                localStorage.setItem(
                    'companies-info',
                    JSON.stringify(company_data['company_info'])
                );

                // Organizando os dados dos banner
                localStorage.setItem(
                    'banner',
                    JSON.stringify(company_data['company_banner'])
                );

                setTimeout(() => {
                    if (loading) {
                        location.reload();
                    } else {
                        /** spinner ends after 5 seconds */
                        this.spinnera.hide();
                    }
                }, 1000);
            });
    }
}
